// Brand color plumbing. Tailwind's `primary` color is defined as
// `rgb(var(--brand) / <alpha-value>)`, so --brand must hold a SPACE-SEPARATED
// RGB triplet (e.g. "15 42 71"), not a hex string. The org's brandColor is
// stored as hex, so convert before applying. The :root default in globals.css
// matches the original primary (#0F2A47) so orgs that never set a color look
// unchanged.

export function brandRgbTriplet(hex: string): string | null {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex.trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

export function applyBrandColor(hex: string | null | undefined): void {
  if (!hex) return;
  const triplet = brandRgbTriplet(hex);
  if (triplet) document.documentElement.style.setProperty('--brand', triplet);
}
